export const GA_SECTION_NAMES = {
  EPG: 'Señal en vivo',
  SERIE: 'Serie',
  MOVIE: 'Pelicula',
  SEARCH: 'Buscador',
  SPORTS: 'Deportes',
  HOME: 'Inicio',
  SECTION: 'Sección',
};
